export default __webpack_public_path__ + "4fe8f495ac9544845022df6c4a836ca1.png";